/**
 * KTUI - Free & Open-Source Tailwind UI Components by Keenthemes
 * Copyright 2025 by Keenthemes Inc
 */

export { KTTooltip } from './tooltip';
export type { KTTooltipConfigInterface, KTTooltipInterface } from './types';
